<template>
  <div>


    <div style="text-align: left;">
      <H5>留学总览 </H5>
      <el-button style="position: absolute;right: 0;top: 0"  type="primary" @click="close_assembly">返回</el-button>
      <el-divider></el-divider>
    </div>

    <el-descriptions :title="userProcessesInfoData.title">
      <el-descriptions-item label="状态">
        <el-tag :size="TagStatusSize[userProcessesInfoData.status]">{{TagStatusName[userProcessesInfoData.status]}}</el-tag>

      </el-descriptions-item>
      <el-descriptions-item label="规划时间" v-if="userProcessesInfoData.plan_time">{{userProcessesInfoData.plan_time}} </el-descriptions-item>
      <el-descriptions-item label="规划时间" v-else>未设置</el-descriptions-item>
      <el-descriptions-item label="最后更新时间"  v-if="userProcessesInfoData.last_time">{{userProcessesInfoData.last_time}}</el-descriptions-item>
      <el-descriptions-item label="完成时间" v-if="userProcessesInfoData.finished_time">{{userProcessesInfoData.finished_time}} </el-descriptions-item>
    </el-descriptions>
    <div style="margin-top: 1rem">
      <el-descriptions title="当前进度">
      </el-descriptions>
      <el-progress :text-inside="true" :stroke-width="24" :percentage="userProcessesInfoData.comment_percentage" :status="userProcessesInfoData.comment_percentage == 100 ? 'success ' : ''"></el-progress>
    </div>



    <div style="margin-top: 1rem">
      <el-descriptions title="所有代办"> </el-descriptions>
      <el-collapse v-model="activeNames" @change="handleChange">
        <div v-if="usrPcsPcsInfData.length>0" v-for="(list, index) in usrPcsPcsInfData" >
          <el-collapse-item  :name="index">
            <template slot="title">
              <span style="font-weight: 700;font-size: 15px">{{list.title}}</span>
              <span :class="needDoClass[list.status]"  v-b-toggle="'list'+list.id" style="margin-left: 1rem">
                {{ needDoStatus[list.status] }}
              </span>
            </template>
            <div style="text-align: left">
              <div>创建时间：{{list.created_at}}</div>
              <div v-if="list.end_time">代办规划时间：{{list.end_time}}</div>
              <div v-else>代办规划时间：未设置</div>
              <div>
                <div class="wait-name ">素材</div>
                <ul class="list-unstyled">
                  <li class="file-lsit" v-for="iteam in JSON.parse(list.files)">
                    <p>
                      <span v-if="checkUrlType(iteam.file)" @click="showBigImg(iteam.file)" >{{iteam.name}}</span>
                      <span v-else>{{iteam.name}}</span>
                      <span @click="exportFile(iteam.file,iteam.name)" style="margin-left: 1rem"><b-icon class="down-file" icon="download"></b-icon></span>
                    </p>
                  </li>
                </ul>
                <div v-for="(userprocesses,index) in list.user_processes_info_finish">
                  <div class="wait-name ">{{list.title}}素材,第{{list.user_processes_info_finish.length-index}}版</div>
                  <div>
                    <ul class="list-unstyled">
                      <li class="file-lsit"  v-for="contents in JSON.parse(userprocesses.content) ">
                        <p>
                          <span v-if="checkUrlType(contents.value)" @click="showBigImg(contents.value)" v-on:mouseover="show_img(list.id,contents.value)" v-on:mouseout="hide_img(list.id)">{{contents.title}}</span>
                          <span v-else>{{contents.title}}</span>
                          <span @click="exportFile(contents.value,contents.title)" style="margin-left: 1rem"><b-icon class="down-file" icon="download"></b-icon></span>
                        </p>
                      </li>
                      <li class="examine-content" v-if="userprocesses.comment" >{{userprocesses.comment}}</li>
                    </ul>
                    <div v-if="userprocesses.student_document" style="margin-bottom: 1rem">
                      <div class="audit-content" style="margin: 0 auto">
                        <span>老师回传文件</span>
                      </div>
                      <ul class="list-unstyled" >
                        <li class="file-lsit"   v-for="contents in userprocesses.student_document.document " style="padding-left: 1rem ">
                          <p>
                            <span v-if="checkUrlType(contents.url)"  @click="showBigImg(contents.url)" >{{contents.name}}</span>
                            <span v-else>{{contents.name}}</span>
                            <span @click="exportFile(contents.url,contents.name)" style="margin-left: 1rem"><b-icon class="down-file" icon="download"></b-icon></span>
                          </p>
                        </li>
                        <li class="examine-content" v-if="userprocesses.comment" >{{userprocesses.comment}}</li>
                      </ul>
                    </div>
                    <div class="audit-content">
                    <span v-if="userprocesses.created_at">{{userprocesses.created_at}}上传
                      <span :class="list.need_review==1?needDoClass2[userprocesses.status]:''">
                        {{list.need_review==1?userProcessesStatus[userprocesses.status]:'无需审核'  }}
                      </span>
                    </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </el-collapse-item>
        </div>


      </el-collapse>
    </div>


    <div class="c1" id="mask" @click="closeImg()">
      <div id="advert" >
        <img :src="clickbigUrl" alt="加载失败">
      </div>
    </div>

  </div>
</template>
<script>

import { getUserProcessInfo} from "@/api/overview.js";

export default {
  name: "OverviewInfo",
  props: {
    user_process_id:{
      default: ''
    },
  },
  data() {
    return {
      clickbigUrl:'',
      activeNames: [],
      userProcessesInfoData:[],
      usrPcsPcsInfData:[],
      TagStatusSize:['info','success','primary'],
      TagStatusName:['未开启','已完成','进行中'],
      needDoStatus: ['待完成',     '已完成', '已上传,等待审核', '审核未通过， 重新上传',   '已通过，等待老师回传文件',  '老师已回传文件',         '已回传,待审核',  '回传未通过，重新上传'], // 未通过状态
      needDoClass: ['waiting-for', 'pass', 'waiting-for',   'failed','waiting-for',  'waiting-for',       'waiting-for',          'waiting-for',   'waiting-for'], // 通过class
      needDoClass2: ['', 'pass', 'waiting-for', 'failed'], // 通过class
      userProcessesStatus: ['废弃', '已完成', '正在审核中', '审核未通过，重新上传']

    };
  },
  computed: {

  },
  created() {
    this.getList();
  },
  methods: {
    checkUrlType(url){
      return (url.match(/\.(jpeg|jpg|gif|png)$/) != null)
    },
    close_assembly(){
      console.log(123123)
      this.$emit('closeView',1);//select事件触发后，自动触发showCityName事件
    },
    getList(){
      console.log('请求id',this.user_process_id)
      getUserProcessInfo({'user_process_id':this.user_process_id}).then(response => {
        console.log('请求成功,内容：',response)
        this.userProcessesInfoData = response.data.userProcessesInfoData
        this.usrPcsPcsInfData = response.data.usrPcsPcsInfData
        console.log(this.usrPcsPcsInfData)
      })
    },
    showBigImg(value){
      this.clickbigUrl = value
      document.getElementById('mask').style.display = "block";
      document.getElementById('advert').style.display = "block";
    },
    closeImg(){
      this.clickbigUrl = '';
      document.getElementById('mask').style.display = "none";
      document.getElementById('advert').style.display = "none";
    },
    handleChange(val) {
      console.log(val);
    },
    exportFile(data, fileName, _this){

      // 地址不存在时，禁止操作
      if(!data)return;
      // 下载文件并保存到本地
      const callback = (data)=>{
        // 创建a标签，使用 html5 download 属性下载，
        const link = document.createElement('a');
        // 创建url对象
        const objectUrl = window.URL.createObjectURL(new Blob([data]));
        link.style.display='none';
        link.href=objectUrl;
        // 自定义文件名称， fileName
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        // 适当释放url
        window.URL.revokeObjectURL(objectUrl);
      };
      // 把接口返回的url地址转换为 blob
      const xhr = new XMLHttpRequest();
      xhr.open('get', data, true);
      xhr.responseType = 'blob';
      xhr.onload = ()=> {
        // 返回文件流，进行下载处理
        callback(xhr.response);
      };
      xhr.send(); // 不要忘记发送
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/components/mycenter/component/overview_info.vue